/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0.3);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}
:host .popup {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -12.5rem;
  margin-top: -8rem;
  background-color: white;
  width: 25rem;
  height: 16rem;
}
:host .popup .popupContent {
  position: absolute;
  left: 0;
  top: 5rem;
  width: 20rem;
  margin-left: 2.5rem;
  margin-right: 2.5rem;
  display: grid;
  grid-template-columns: 5rem 5rem 5rem 5rem;
  grid-template-rows: 2rem 3.5rem 1rem;
  grid-column-gap: 0;
  grid-row-gap: 0.5rem;
}
:host .popup[touch] {
  width: 22rem;
  height: 15rem;
  margin-left: -11rem;
  margin-top: -7.5rem;
}
:host .popup[touch] .popupContent {
  width: 15rem;
  margin-left: 3.5rem;
  margin-right: 3.5rem;
  grid-template-columns: 5rem 5rem 5rem;
  grid-template-rows: 2rem 3.5rem;
}
:host .closeButton {
  position: absolute;
  right: 2rem;
  top: 2rem;
  background-color: transparent;
  border: 0 solid black;
  outline: none;
  padding: 0.5rem;
  cursor: pointer;
}
:host .closeIcon {
  fill: #737F85;
  fill: var(--davinci-color-secondary, #737F85);
  width: 1.25rem;
  height: 1.25rem;
}
:host .popupIcon {
  place-self: center;
  fill: #737F85;
  fill: var(--davinci-color-secondary, #737F85);
}
:host .actionIcon {
  width: 2rem;
  height: 2rem;
}
:host .mouseIcon {
  width: 2.25rem;
  height: 3rem;
}
:host .mouseActionText {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
  font-size: 1rem;
  font-weight: 600;
  place-self: center;
}`;
export { style };
